<div class="eb-favorites-list">
  <div class="eb-favorites-list__actions">
    <button class="eb-favorites-list__add-new-list" (click)="createNewFavoritesList()">
      {{ 'favorites.add.new' | cxTranslate }}
      <em class="fas fa-plus"></em>
    </button>
  </div>
  <ul *ngIf="lists$ | async as lists">
    <li
      *ngFor="let list of lists"
      class="eb-favorites-list__entry"
      [ngClass]="{
        'eb-favorites-list__entry--selected':
          isSelected(list.code, list.recommendationsList) | async
      }"
      (click)="showDetails(list)"
    >
      <div class="eb-favorites-list__listName">
        <label class="eb-favorites-list__entry-name" [attr.data-cy]="'fav-list-' + list.name">{{
          list.name
        }}</label>
      </div>
      <div class="eb-favorites-list__listStatus">
        <span class="eb-favorites-list__entry-shared">
          {{ 'favorites.list.entry.' + (list.shared ? 'shared' : 'private') | cxTranslate }}
        </span>
      </div>
      <button
        *ngIf="!list.recommendationsList && list.isOwner"
        class="cx-remove-btn link eb-favourites-list__entry-remove"
        [attr.data-cy]="'remove-fav-list-' + list.name"
        (click)="deleteFavoritesList(list)"
      >
        {{ 'common.remove' | cxTranslate }}
      </button>
    </li>
  </ul>
  <eb-spinner *ngIf="listsLoading$ | async" size="2" alignment="center" width="100%"></eb-spinner>
</div>
